import React from 'react';
import { ArrowRight, Globe, Shield, Zap } from 'lucide-react';
import { heroContent } from '../data/mock';

const HeroSection = () => {
  return (
    <section id="home" className="dark-container min-h-screen flex items-center">
      <div className="dark-content-container w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h1 className="display-huge">
                {heroContent.mainHeading}
              </h1>
              <h2 className="display-medium" style={{ color: '#00FFD1' }}>
                {heroContent.subHeading}
              </h2>
              <p className="body-large max-w-2xl">
                {heroContent.description}
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="#services" className="btn-primary">
                <span>Explore Solutions</span>
                <ArrowRight size={20} />
              </a>
              <a href="#contact" className="btn-secondary">
                <span>Contact Us</span>
              </a>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 pt-12">
              {heroContent.stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="display-medium" style={{ color: '#00FFD1' }}>
                    {stat.number}
                  </div>
                  <div className="body-small text-gray-400">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content - Visual Elements */}
          <div className="relative">
            <div className="relative z-10 p-12 rounded-lg" style={{ 
              background: 'rgba(255, 255, 255, 0.05)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(0, 255, 209, 0.2)'
            }}>
              
              {/* Tech Icons Grid */}
              <div className="grid grid-cols-3 gap-8 mb-8">
                <div className="flex flex-col items-center space-y-3 p-4 rounded-lg" style={{ 
                  background: 'rgba(0, 255, 209, 0.1)' 
                }}>
                  <Globe size={32} style={{ color: '#00FFD1' }} />
                  <span className="text-sm text-center">IoT Solutions</span>
                </div>
                <div className="flex flex-col items-center space-y-3 p-4 rounded-lg" style={{ 
                  background: 'rgba(0, 255, 209, 0.1)' 
                }}>
                  <Shield size={32} style={{ color: '#00FFD1' }} />
                  <span className="text-sm text-center">Blockchain</span>
                </div>
                <div className="flex flex-col items-center space-y-3 p-4 rounded-lg" style={{ 
                  background: 'rgba(0, 255, 209, 0.1)' 
                }}>
                  <Zap size={32} style={{ color: '#00FFD1' }} />
                  <span className="text-sm text-center">AI Solutions</span>
                </div>
              </div>

              {/* MENA Region Focus */}
              <div className="text-center space-y-4">
                <h3 className="heading-2">Serving the MENA Region</h3>
                <p className="body-medium">
                  From Dubai to the entire Middle East and North Africa, delivering innovative technology solutions
                </p>
              </div>
            </div>

            {/* Background Elements */}
            <div className="absolute inset-0 -z-10">
              <div className="absolute top-1/4 left-1/4 w-32 h-32 rounded-full" style={{ 
                background: 'radial-gradient(circle, rgba(0, 255, 209, 0.1) 0%, transparent 70%)'
              }}></div>
              <div className="absolute bottom-1/4 right-1/4 w-48 h-48 rounded-full" style={{ 
                background: 'radial-gradient(circle, rgba(0, 255, 209, 0.05) 0%, transparent 70%)'
              }}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;